var _style, _polyline, _polyline2, _polyline3, _polyline4, _rect, _rect2, _rect3, _rect4, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAiGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#41D8A6;stroke-width:8;stroke-miterlimit:10;}\n\t.st1{fill:#6325A5;}\n\t.st2{fill:#41D8A6;}\n\t.st3{fill:none;stroke:#41D8A6;stroke-width:6;stroke-miterlimit:10;}\n\t.st4{fill:#BC31A2;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "365.7,92.8 419.2,92.8 419.2,146.3 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "92.8,146.3 92.8,92.8 146.3,92.8 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "146.3,419.2 92.8,419.2 92.8,365.7 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "419.2,365.7 419.2,419.2 365.7,419.2 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 299.3,
    y: 207.5,
    className: "st1",
    width: 76.5,
    height: 97
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 462.3,
    y: 207.5,
    className: "st1",
    width: 49.7,
    height: 97
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 207.5,
    className: "st1",
    width: 49.7,
    height: 97
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136.2,
    y: 207.5,
    className: "st1",
    width: 76.5,
    height: 97
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 207.5,
    className: "st1",
    width: 76.5,
    height: 97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 256,
    cy: 256,
    r: 21.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 256,
    cy: 256,
    r: 31.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.7,
    y: 207.5,
    className: "st1",
    width: 76.5,
    height: 97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 93,
    cy: 256,
    r: 21.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 380.8,
    y: 207.5,
    className: "st1",
    width: 76.5,
    height: 97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 419,
    cy: 256,
    r: 21.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAiGo);
export default __webpack_public_path__ + "static/media/logo-ai-go.5b91cc4421fa84838ccddcc38c477888.svg";
export { ForwardRef as ReactComponent };